<template>
    <h3 class="flex my-3 text-xl leading-6 font-large dark:text-white item-center">
        <store-modal
            :attendant="editing"
            @fetch="fetch"
            @close="editing = null"
        />
    </h3>

    <p class="px-6 mb-2 text-sm text-gray-500 dark:text-gray-400 lg:px-8">
        Leads do Ticto Forms com faturamento acima de R$ 10.000,00 são direcionados para o WhatsApp de um destes
        atendentes, em rodízio. Quem está há mais tempo sem receber lead é o próximo da vez.
    </p>

    <div v-if="!loading && attendants.length > 0" class="mb-2 mt-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full sm:px-6 lg:px-8">
            <div class="relative overflow-hidden rounded-xl bg-slate-50 dark:bg-slate-800/25">
                <table class="w-full table-auto border-collapse text-sm">
                    <thead>
                        <tr>
                            <th scope="col" class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200" width="140px">
                                Ações
                            </th>
                            <th scope="col" class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200">
                                Atendente
                            </th>
                            <th scope="col" class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200" width="180px">
                                WhatsApp
                            </th>
                            <th scope="col" class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200" width="120px">
                                Recebendo
                            </th>
                            <th scope="col" class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200" width="110px">
                                Leads
                            </th>
                            <th scope="col" class="px-6 py-4 text-left text-sm font-medium dark:text-slate-200" width="180px">
                                Último lead
                            </th>
                        </tr>
                    </thead>
                    <tbody class="bg-white dark:bg-slate-800">
                        <tr v-for="attendant in attendants" :key="attendant.id">
                            <td class="table-cell-sm">
                                <button
                                    @click="editing = attendant"
                                    :disabled="loading"
                                    class="text-blue-500 hover:text-blue-700 text-sm font-medium"
                                    :class="{ 'cursor-not-allowed opacity-50': loading }"
                                >
                                    Editar
                                </button>
                                <button
                                    @click="destroy(attendant)"
                                    :disabled="loading"
                                    class="ml-3 text-red-600 hover:text-red-800 text-sm font-medium"
                                    :class="{ 'cursor-not-allowed opacity-50': loading }"
                                >
                                    Excluir
                                </button>
                            </td>
                            <td class="table-cell-sm" style="padding:0.75rem">
                                <span :title="attendant.name" class="block">{{ attendant.name }}</span>
                                <span v-if="attendant.created_by" class="block text-xs text-gray-400">
                                    cadastrado por {{ attendant.created_by }}
                                </span>
                            </td>
                            <td class="table-cell-sm">
                                <a
                                    :href="`https://wa.me/${attendant.phone}`"
                                    target="_blank"
                                    class="text-blue-500 hover:text-blue-700"
                                >
                                    {{ attendant.phone }}
                                </a>
                            </td>
                            <td class="table-cell-sm">
                                <button
                                    @click="toggle(attendant)"
                                    :disabled="loading"
                                    class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2"
                                    :class="attendant.is_active ? 'bg-indigo-600' : 'bg-gray-200'"
                                >
                                    <span class="sr-only">{{ attendant.is_active ? 'Desativar' : 'Ativar' }}</span>
                                    <span
                                        aria-hidden="true"
                                        class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                        :class="attendant.is_active ? 'translate-x-5' : 'translate-x-0'"
                                    ></span>
                                </button>
                            </td>
                            <td class="table-cell-sm">
                                {{ attendant.assignments_count }}
                            </td>
                            <td class="table-cell-sm">
                                {{ attendant.last_assigned_at ?? '-' }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <empty-state class="mt-4" v-if="!loading && !attendants.length" />

    <div v-if="loading">
        <h3 class="my-3 text-sm font-bold font-medium text-gray-400">
            Buscando registros...
        </h3>
    </div>
</template>

<script>
    import { useToast } from "vue-toastification";
    import EmptyState from "../../components/layouts/EmptyState.vue";
    import StoreModal from "../../components/config/modals/LeadRoutingAttendantStoreModal.vue";

    export default {
        components: {
            EmptyState,
            StoreModal,
        },

        data() {
            return {
                loading: true,
                attendants: [],
                editing: null,
            }
        },

        setup() {
            const toast = useToast();
            return { toast };
        },

        mounted() {
            this.fetch();
        },

        methods: {
            fetch() {
                this.loading = true;
                axios
                    .get('/api/lead-routing/attendants')
                    .then(({data}) => {
                        this.attendants = data.data;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            toggle(attendant) {
                const questionText = attendant.is_active
                    ? 'Parar de enviar leads para este atendente?'
                    : 'Voltar a enviar leads para este atendente?';
                const successText = attendant.is_active
                    ? 'Atendente não vai mais receber leads.'
                    : 'Atendente voltou para o rodízio.';

                if (confirm(questionText)) {
                    this.loading = true;
                    axios
                        .put(`/api/lead-routing/attendants/${attendant.id}/toggle`)
                        .then(() => {
                            this.toast.success(successText);
                            this.fetch();
                        })
                        .catch(({response: {data: { message }}}) => {
                            this.toast.error(message);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
            destroy(attendant) {
                if (confirm('Tem certeza que deseja excluir este atendente?')) {
                    this.loading = true;
                    axios
                        .delete(`/api/lead-routing/attendants/${attendant.id}`)
                        .then(() => {
                            this.toast.success("Atendente removido com sucesso!");
                            this.fetch();
                        })
                        .catch(({response: {data: { message }}}) => {
                            this.toast.error(message);
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            },
        }
    }
</script>
